import translateLanguage from 'common-translations/src/vtj/translate-language'
import { observer } from 'mobx-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Block, Heading } from 'suomifi-ui-components'
import LocalizedString from 'todistukset-ui/src/vtj/components/localized-string/LocalizedString.react'
import { Columns } from 'todistukset-ui/src/vtj/components/order-wizard-aet-shared/AetCommonFormComponents.sc'
import InfoItem from 'todistukset-ui/src/vtj/components/order-wizard-aet-shared/InfoItem.react'
import { AetOrdererUiForm } from 'todistukset-common/src/vtj/types/form-types.type'
import { useStore } from 'todistukset-ui/src/vtj/stores/store.util'
import { finalEditableFieldValue } from 'todistukset-common/src/vtj/types/editable-field.type'
import { TodistusPyyntöAet } from 'todistukset-common/src/vtj/types/todistus'

interface AetSummaryTodistusInfoProps {
  isKirkollinenVihkiminen: AetOrdererUiForm['isKirkollinenVihkiminen']
  todistusLanguage: TodistusPyyntöAet['todistusLanguage']
  placeOfMarriage: AetOrdererUiForm['placeOfMarriage']
}

const AetSummaryTodistusInfo: React.FC<AetSummaryTodistusInfoProps> = observer(
  ({ isKirkollinenVihkiminen, todistusLanguage, placeOfMarriage }) => {
    const { t } = useTranslation()

    const {
      common: { lang },
    } = useStore()

    const translatedIsKirkollinenVihkiminen = finalEditableFieldValue(
      isKirkollinenVihkiminen
    )
      ? t('yes')
      : t('no')

    const placeOfMarriageValue = finalEditableFieldValue(placeOfMarriage)
    const translatedPlaceOfMarriage = placeOfMarriageValue
      ? t(`aetSummaryPlaceOfMarriage_${placeOfMarriageValue}`)
      : '-'

    const todistusLanguageValue = finalEditableFieldValue(todistusLanguage)
    const translatedTodistusLanguage = todistusLanguageValue
      ? translateLanguage({ code: todistusLanguageValue, lang })
      : '-'

    return (
      <Block variant="section">
        <Heading variant="h3">
          <LocalizedString stringKey="aetSummaryTodistusInfoTitle" />
        </Heading>
        <Columns>
          <InfoItem
            title={t('aetSummaryKirkollinenVihkiminenLabel')}
            content={translatedIsKirkollinenVihkiminen}
          />
          <InfoItem
            title={t('aetSummaryTodistusLanguageLabel')}
            content={translatedTodistusLanguage}
          />
          <InfoItem
            title={t('aetSummaryPlaceOfMarriageLabel')}
            content={translatedPlaceOfMarriage}
          />
        </Columns>
      </Block>
    )
  }
)

export default AetSummaryTodistusInfo
